export const controlButtonDiv = {
  margin: "10px",
  zIndex: 10,
  position: "absolute",
  cursor: "pointer",
  left: "168px",
  top: "0px",
};

export const closeButtonDiv = {
  margin: "10px",
  zIndex: 10,
  position: "absolute",
  cursor: "pointer",
  right: "0px",
  top: "0px",
};
export const controlButtonWrapper = {
  position: "relative",
  float: "left",
  display: "flex",
};
export const controlButton = (hover, open = false) => {
  return {
    background: "none padding-box rgb(255, 255, 255)",
    backgroundColor: open
      ? "#6096d1"
      : hover
      ? "rgb(235, 235, 235)"
      : "rgb(255, 255, 255)",
    display: "table-cell",
    border: "0px",
    margin: "0px",
    padding: "0px 17px",
    textTransform: "none",
    appearance: "none",
    position: "relative",
    cursor: "pointer",
    userSelect: "none",
    direction: "ltr",
    overflow: "hidden",
    textAlign: "center",
    height: "40px",
    verticalAlign: "middle",
    color: "rgb(0, 0, 0)",
    fontFamily: "Roboto, Arial, sans-serif",
    fontSize: "18px",
    borderBottomRightRadius: "2px",
    borderTopRightRadius: "2px",
    boxShadow: "rgb(0 0 0 / 30%) 0px 1px 4px -1px",
    minWidth: "36px",
  };
};

export const ulStyle = {
  backgroundColor: "white",
  listStyle: "none",
  padding: "2px",
  margin: "0px",
  zIndex: -1,
  borderBottomLeftRadius: "2px",
  borderBottomRightRadius: "2px",
  boxShadow: "rgb(0 0 0 / 30%) 0px 1px 4px -1px",
  position: "absolute",
  left: "0px",
  top: "40px",
  textAlign: "left",
  display: "none",
};

export const liStyle = {
  color: "black",
  fontFamily: "Roboto, Arial, sans-serif",
  userSelect: "none",
  fontSize: "18px",
  backgroundColor: "rgb(255, 255, 255)",
  padding: "5px 8px 5px 5px",
  direction: "ltr",
  textAlign: "left",
  whiteSpace: "nowrap",
};

export const inputStyle = {
  height: "1em",
  width: "1em",
  transform: "scale(1.5)",
  marginRight: "15px",
};
